import { css } from '@/styled-system/css';

export const fallbackPhotoStyles = css.raw({
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: '160px',
  backgroundColor: 'bg.accent.blue.soft',
  borderRadius: '100',
});
